const CLIENT_URL = process.env.REACT_APP_WS02_CLIENT_KEY as string;
const CLIENT_SECRET = process.env.REACT_APP_WS02_CLIENT_SECRET as string;
const AUTH_END_POINT = process.env.REACT_APP_WS02_END_POINT as string;
const XSM_BASE_URL = process.env.REACT_APP_XSM_API_BASE_URL as string;
const REACT_AUTH_ENDPOINT = process.env.REACT_APP_FRONTEND_BASE_URL as string;
const XSM_DOMAIN = process.env.REACT_APP_USER_DOMAIN as string;
const XSM_APPLICATION = process.env.REACT_APP_XSM_APPLICATION as string;
const XSM_ORIGIN = process.env.REACT_APP_XSM_ORIGIN as string;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string;

export {
  AUTH_END_POINT,
  CLIENT_URL,
  REACT_AUTH_ENDPOINT,
  XSM_BASE_URL,
  XSM_DOMAIN,
  XSM_APPLICATION,
  XSM_ORIGIN,
  CLIENT_SECRET,
  API_BASE_URL,
};
